import './alert.scss';

const Alert = () => <span className="alert-circle">!</span>;

export default Alert;
